import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import SearchBox from '../SearchBox/SearchBox';
import Loading from '../common/Loading';
import 'whatwg-fetch';
import moment from 'moment';
import { searchParams } from '../common/utils.js';
import { createAvailibilityDatesDict } from '../../utils/availablility.utils.js';
import { DATES_MOMENT_FORMAT } from '../common/constants.js';
import { END_DATE } from 'react-dates/constants';
import styles from './styles.less';

class SearchBoxController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAllDates: true,
      serverUrl: props.serverUrl,
      asyncProps: {},
      isLoading: true,
      loadingMessage: "Loading SearchBox... :)",
      checkinAvailability: {},
      checkoutAvailability: {},
      availabilityLoading: false,
      offlineAvailability: true,
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextserverUrl = nextProps.serverUrl;
    const { serverUrl } = this.state;
    if (nextserverUrl != serverUrl) {
      this.setState({
        serverUrl: nextserverUrl
      });
    }
  }

  componentDidMount() {
    const { serverUrl } = this.state;
    if (serverUrl) {
      let configUrl = serverUrl.replace(this.getUrlActionPlaceHolder(), "cdn/config");
      fetch(configUrl,
        {
          credentials: 'same-origin'
        })
        .then((res) => res.json())
        .then((obj) => {
          obj = JSON.parse(obj);
          const { selectedOption, checkinDate, searchOptions } = obj;
          this.generateSelectedOption(obj);
          this.setState({
            isLoading: false,
            asyncProps: { ...this.state.asyncProps, ...obj }
          }, () => {
            const { selectedOption, checkinDate } = this.state.asyncProps;
            const isObject = typeof selectedOption === "object";
            const isHotel = selectedOption.optionType === "Hotel";
            if (isObject && isHotel) {
              this.initAvailability(checkinDate);
            }
            this.setOpenAllDates();
          });

        }, (er) => {
          throw er;
        })
        .catch((er) => {
          console.log(`Failed to fetch config data: ${er}`);
          this.setState({ loadingMessage: "Can't get data :(" });
        });

    }
  }

  setOpenAllDates = () => {
    // open all dates if searchOption is not a hotel
    const { asyncProps: { selectedOption } } = this.state;
    this.setState({ openAllDates: selectedOption && selectedOption.optionType !== "Hotel" });
  }

  // summery: regenerate async props object to set selectedOption property to default if its only one hotel chain.
  // params: asyncProps= referance object to original asyncProps object.
  generateSelectedOption(asyncProps) {
    const { selectedOption, checkinDate, searchOptions, results_roomCategory } = asyncProps;
    if (results_roomCategory) {
      // in case we got selectedOption from external source like querystring or data-attribute
      const newSelectedOption = searchOptions.find(x => x.optionType == "Hotel" && x.value === selectedOption.value);

      // update the selectedOption with the other values of the object in case we only got the selectedOption.value property
      asyncProps.selectedOption = newSelectedOption;

      // disable hotels dropdown if we on a single room search
      //asyncProps.enabledRegionSelection = false;

      return;
    }

    if (typeof selectedOption == "object") return;
    else {
      if (Array.isArray(searchOptions) && searchOptions.length < 3) {
        const newSelectedOption = searchOptions.find(x => x.optionType == "Hotel");
        asyncProps.selectedOption = newSelectedOption;
      }
    }
  }

  getUrlActionPlaceHolder = () => {
    return "actionUrl";
  }

  getAgentLoginUrl = () => {
    const { serverUrl, asyncProps } = this.state;
    return serverUrl.replace(this.getUrlActionPlaceHolder(), "home/AgentLogin");
  }


  // summery: handle of next or prev month click.
  // set checkin availability for one month later (earliar) from last (first) day with availability .
  // params: currentDisplayDate= moment type date for current displayed date after next/prev click.
  onNextMonthClick = (currentDisplayDate) => {
    const { checkinAvailability } = this.state;

    //sort avail dic
    let checkinAvailabilityArr = Object.keys(checkinAvailability);
    checkinAvailabilityArr.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return moment(a, DATES_MOMENT_FORMAT).toDate() - moment(b, DATES_MOMENT_FORMAT).toDate();
    });

    //get last day from checkin availability array
    let lastDayWithAvailability = checkinAvailabilityArr[Object.keys(checkinAvailability).length - 1];
    //convert last day from string type to moment type
    lastDayWithAvailability = moment(lastDayWithAvailability, DATES_MOMENT_FORMAT);

    lastDayWithAvailability.startOf('month');
    currentDisplayDate.startOf('month');
    const isFetchingNeeded = lastDayWithAvailability.diff(currentDisplayDate, 'month') < 4;
    if (!isFetchingNeeded) return;
    this.setHotelAvailability({
      forDate: lastDayWithAvailability,
      isInit: false,
      isCheckOut: false,
      isNextMonthClick: true
    });
  }
  onPrevMonthClick = (currentDisplayDate) => {
    const { checkinAvailability } = this.state;
    const curr = moment();

    //sort avail dic
    let checkinAvailabilityArr = Object.keys(checkinAvailability);
    checkinAvailabilityArr.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return moment(a, DATES_MOMENT_FORMAT).toDate() - moment(b, DATES_MOMENT_FORMAT).toDate();
    });

    let lastDayWithAvailability = checkinAvailabilityArr[0];
    lastDayWithAvailability = moment(lastDayWithAvailability, DATES_MOMENT_FORMAT);

    const isLastDayToday = lastDayWithAvailability.diff(curr, 'days') == 0;

    const normalizedLastDayWithAvailability = moment(lastDayWithAvailability.startOf('month'));
    const normalizedCurrentDisplayDate = moment(currentDisplayDate.startOf('month'));

    const isFetchingNeeded = normalizedCurrentDisplayDate.diff(normalizedLastDayWithAvailability, 'month') < 4;

    if (!isFetchingNeeded
      || isLastDayToday) return;

    this.setHotelAvailability({
      forDate: lastDayWithAvailability,
      isInit: false,
      isCheckOut: false,
      isNextMonthClick: false
    });
  }

  // summery: initial of availability dics (checkin/out).
  // set checkin availability for current date if checkin isnt selected in session.
  // set checkout availability for selected checkin date only if checkin is selected.
  // params: checkinDate= selected checkin date(string format) from session
  initAvailability = (checkinDate, isInit = true) => {
    const forDate = checkinDate ? moment(checkinDate, this.state.asyncProps.displayDateFormat) : moment();
    const isCheckoutNeeded = forDate.diff(moment(), 'days') > 0;
    //get checkin availability
    this.setHotelAvailability({
      forDate: forDate,
      isInit: isInit,
      isCheckOut: false
    });
    if (isCheckoutNeeded)
      //get checkout availability
      this.setHotelAvailability({
        forDate: forDate,
        isInit: isInit,
        isCheckOut: true
      });
  }


  // summery: create object with the relavent values for the post request. 
  // at init/hotel selecting , date range will be (fromDate-[presetDate or 3 month])-(6 month later)
  // at updating availability (next/prev month), 
  // date range will be one month later (for prev month, one month earliar) from last day with availability 
  // params: config = {   forDate = relavent date to get availability for , 
  //                      isCheckout = true for checkout availability ,
  //                      isNextMonthClick = true for updating availavbility for future dates } 
  //         isCheckin = true if checkin is already selected
  getAvailabilityPostData = (config, isCheckin) => {
    const { queryStringObj } = this.props;
    const { results_roomCategory } = queryStringObj;

    if (typeof config.forDate == 'string') {
      config.forDate = moment(config.forDate, this.state.asyncProps.displayDateFormat);
    }

    let fromDate = moment(config.forDate);
    let toDate = moment(config.forDate);

    //if request for initial data - 6 month range of availability
    if ((config.isInit || !isCheckin) && !config.isCheckOut) {
      const curr = moment();
      // if selected checkin date is not the current date - 6 month range sum, before and after
      if (config.forDate.isAfter(curr, 'days')) {

        const diffFromCurr = config.forDate.diff(curr, 'days');
        if (diffFromCurr > 90) {
          fromDate = fromDate.subtract(90, 'days');
          toDate = toDate.add(90, 'days');
        }
        else {
          fromDate = fromDate.subtract(diffFromCurr+1, 'days');
          toDate = toDate.add(180 - diffFromCurr-1, 'days');
        }

      }
      // if selected checkin date is current date - 6 month forward of availability
      else toDate = toDate.add(180, 'days');
    }
    else {
      //if request for checkout availability - 2 month from checkin  (2 months requested by shiri)
      if (config.isCheckOut) toDate = toDate.add(2, 'month');
      //if request for updating data - clicking next or prev month - 1 month of availability
      else
        if (config.isNextMonthClick) {
          toDate = toDate.add(1, 'month');
        }
        else
          if (!config.isNextMonthClick) {
            fromDate = fromDate.subtract(1, 'month');
          }
    }

    const postData = {
      hotelID: parseInt(this.state.asyncProps.selectedOption.value),
      fromDate: fromDate.format(DATES_MOMENT_FORMAT),
      toDate: toDate.format(DATES_MOMENT_FORMAT),
      isPackage: false,
      ...results_roomCategory && results_roomCategory
    }
    if (config.isCheckOut) {
      postData["arrivalDate"] = fromDate.format(DATES_MOMENT_FORMAT);
    }
    return postData;
  }


  // summery: set hotel checkin/out availability object in state with updated data - performing ajax request
  // params: config = {   forDate = relavent date to get availability for , 
  //                      isCheckout = true for checkout availability ,
  //                      isNextMonthClick = true for updating availavbility for future dates } 
  setHotelAvailability = (config) => {
    const { serverUrl, asyncProps } = this.state;
    if (serverUrl && !asyncProps.isOfflineAvailability) {
      const configUrl = serverUrl.replace(this.getUrlActionPlaceHolder(), "Home/GetCalendarAvailability");
      const postData = this.getAvailabilityPostData(config, !!asyncProps.checkinDate);
      const promise = fetch(configUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: searchParams(postData)
      });
      this.setState({
        availabilityLoading: true
      }, () => {
        promise.then((res) => res.json())
          .then((obj) => {
            let nextState = {};
            let nextAvailabilityDic = {};
            if (!config.isCheckOut) {
              const { offlineAvailability, asyncProps } = this.state;
              if (offlineAvailability && (config.isInit || !asyncProps.checkinDate)) {
                nextState.offlineAvailability = false;
              }
              nextAvailabilityDic = { ...this.state.checkinAvailability, ...createAvailibilityDatesDict(obj.data) };
              nextState.checkinAvailability = nextAvailabilityDic;
            } else {
              nextAvailabilityDic = { ...createAvailibilityDatesDict(obj.data) };
              nextState.checkoutAvailability = nextAvailabilityDic;
            }
            nextState.availabilityLoading = false;
            this.setState(nextState);
          });

        promise.catch((er) => {
          this.setState({
            loadingMessage: "Can't get availability :(",
            availabilityLoading: false
          });
          console.warn(`Failed to fetch availability: ${er}`);
        });
      });

    }

  }

  onClickSendSubmitSearchBox = (stateSubmit) => {
    const { onClickSendSubmitSearchBox, disableRedirect, queryStringObj } = this.props;
    const { selectedOption, pax, checkinDate, checkoutDate, promoCode } = stateSubmit;
    const { serverUrl } = this.state;

    // we don't want to duplicate the query string keys, mvc will concatinate the strings eg: hotelId="217,217" (bad!!!).
    const serverUrlWithNoQueryString = serverUrl.substring(0, serverUrl.indexOf("?"));
    const submitUrl = serverUrlWithNoQueryString.replace(this.getUrlActionPlaceHolder(), "reservationProcess/searchresultsProxy");

    //const paramsOnlyAsString = serverUrl.substring(serverUrl.indexOf('?') + 1, serverUrl.length);
    //const paramsAsObject = qs.parse(paramsOnlyAsString, { ignoreQueryPrefix: true, allowDots: true });

    // filter params from url to create one true params in server (conflict between url and searchData)
    const {
      CheckIn,
      CheckOut,
      // param is overridden by param since they have the same name (.net ignore camel case)
      PromoCode,
      Pax,
      SelectedHotelID,
      ListHotelIds,
      ...restParams
    } = queryStringObj;


    const objectToQuery = {
      ...restParams,
      selectedOption,
      pax,
      promoCode,
      checkinDate,
      checkoutDate,
    };

    const newQueryString = qs.stringify(objectToQuery, {
      allowDots: true,
      encode: false,
      addQueryPrefix: true // adding the '?' at the start
    });


    const fullUrl = `${submitUrl}${newQueryString}`

    const nextState = { ...stateSubmit, submitURL: fullUrl };
    onClickSendSubmitSearchBox && onClickSendSubmitSearchBox(nextState)

    // disableRedirect is used internal to disable redirect in storybook
    if (!disableRedirect) top.window.location = nextState.submitURL;
  }

  onChangeCheckinDate = (checkinDate) => {
    let { asyncProps, availabilityLoading } = this.state;
    asyncProps.checkinDate = checkinDate;
    asyncProps.checkoutDate = null;
    this.setState({
      asyncProps,
      checkoutAvailability: {},
      offlineAvailability: availabilityLoading ? true : availabilityLoading
    });
    this.props.onChangeCheckinDate(checkinDate);
  }

  onChangeCheckoutDate = (checkoutDate) => {
    let { asyncProps } = this.state;
    asyncProps.checkoutDate = checkoutDate;
    this.setState({
      asyncProps,
      offlineAvailability: false
    });
    this.props.onChangeCheckoutDate(checkoutDate);
  }

  onChangeHotelsRegions = (selectedOption) => {
    let { asyncProps } = this.state;
    asyncProps.selectedOption = { ...selectedOption };
    asyncProps.checkinDate = null;
    asyncProps.checkoutDate = null;

    this.setState({
      asyncProps: { ...asyncProps },
      checkinAvailability: {},
      checkoutAvailability: {}
    }, () => {
      //on hotel selection => request checkin availability
      if (selectedOption != null && selectedOption.optionType == "Hotel" && parseInt(selectedOption.value) > 0) {
        const forDate = this.state.checkinDate ? moment(this.state.checkinDate, DATES_MOMENT_FORMAT) : moment();
        this.initAvailability(forDate, false);
      }
      // open all dates if searchOption is not a hotel
      this.setState({ openAllDates: selectedOption.optionType !== "Hotel" });
    });

    this.props.onChangeHotelsRegions(selectedOption);
  }

  genOptionTypeFilter = arr => opt => arr.some(o => o === opt.optionType);

  render() {
    const {
      openAllDates,
      asyncProps,
      isLoading,
      checkoutAvailability,
      checkinAvailability,
      availabilityLoading,
      offlineAvailability
    } = this.state;

    // quick and dirty for calendarOpenDirection.
    //TODO: make it more generic, right now props.calendarOpenDirection should win vs asyncProps.calendarOpenDirection.
    const { calendarOpenDirection, queryStringObj } = this.props;
    const { lang } = queryStringObj;
    const { searchOptions, excludeSearchOptions, ...restOfAsyncProps } = asyncProps;
    let filteredSearchOptions = searchOptions;
    if (excludeSearchOptions && excludeSearchOptions.length > 0) {
      const isOptionTypeExcluded = this.genOptionTypeFilter(excludeSearchOptions);
      filteredSearchOptions = searchOptions.filter(opt => !isOptionTypeExcluded(opt))
    }
    return (
      <div>
        {
          isLoading ?
            <Loading shapeClassName={styles.loader} />
            :
            <SearchBox
              offlineAvailability={offlineAvailability}
              openAllDates={openAllDates}
              {...this.props}
              {...restOfAsyncProps}
              searchOptions={filteredSearchOptions}
              lang={lang}
              calendarOpenDirection={calendarOpenDirection || asyncProps.calendarOpenDirection}
              checkoutAvailability={checkoutAvailability}
              checkinAvailability={checkinAvailability}
              availabilityLoading={availabilityLoading}
              LoginLink={this.getAgentLoginUrl()}
              onClickSendSubmitSearchBox={this.onClickSendSubmitSearchBox}
              setHotelAvailability={this.setHotelAvailability}
              initAvailability={this.initAvailability}
              onChangeCheckinDate={this.onChangeCheckinDate}
              onChangeCheckoutDate={this.onChangeCheckoutDate}
              onChangeHotelsRegions={this.onChangeHotelsRegions}
              onNextMonthClick={this.onNextMonthClick}
              onPrevMonthClick={this.onPrevMonthClick}
              resetCheckoutAvailibility={this.resetCheckoutAvailibility}
            />
        }
      </div>
    );
  }
}

SearchBoxController.propTypes = {
  calendarOpenDirection: PropTypes.string,
  serverUrl: PropTypes.string.isRequired,
  disableRedirect: PropTypes.bool,
  onChangePax: PropTypes.func,
  onClickAddRoom: PropTypes.func,
  onClickRemoveRoom: PropTypes.func,
  onChangePromoCode: PropTypes.func,
  onChangeActiveRoom: PropTypes.func,
  onChangeHotelsRegions: PropTypes.func,
  onChangeCheckinDate: PropTypes.func,
  onChangeCheckoutDate: PropTypes.func,
  onClickSendSubmitSearchBox: PropTypes.func
}

SearchBoxController.defaultProps = {
  disableRedirect: false,
  onChangePax() { },
  onClickAddRoom() { },
  onClickRemoveRoom() { },
  onChangePromoCode() { },
  onChangeActiveRoom() { },
  onChangeHotelsRegions() { },
  onChangeCheckinDate() { },
  onChangeCheckoutDate() { },
  onClickSendSubmitSearchBox() { },
}


export default SearchBoxController;



// WEBPACK FOOTER //
// ./src/components/SearchBoxController/SearchBoxController.js